const CONTENT_MAP = {
  idea: { label: "Idea", cls: "bg-violet-500/15 text-violet-300 border-violet-500/30" },
  draft: { label: "Draft", cls: "bg-zinc-500/15 text-zinc-300 border-zinc-500/30" },
  verification: { label: "Verification", cls: "bg-amber-500/15 text-amber-300 border-amber-500/30" },
  editorial_review: { label: "Editorial Review", cls: "bg-pink-500/15 text-pink-300 border-pink-500/30" },
  ready_to_publish: { label: "Ready to Publish", cls: "bg-sky-500/15 text-sky-300 border-sky-500/30" },
  scheduled: { label: "Scheduled", cls: "bg-indigo-500/15 text-indigo-300 border-indigo-500/30" },
  published: { label: "Published", cls: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30" },
  updated: { label: "Updated", cls: "bg-teal-500/15 text-teal-300 border-teal-500/30" },
  unpublished: { label: "Unpublished", cls: "bg-red-500/15 text-red-300 border-red-500/30" },
  rejected: { label: "Rejected", cls: "bg-red-600/20 text-red-300 border-red-600/40" },
  archived: { label: "Archived", cls: "bg-zinc-700/40 text-zinc-400 border-zinc-600/40" },
  // project + claim extras
  monitoring: { label: "Monitoring", cls: "bg-sky-500/15 text-sky-300 border-sky-500/30" },
  researching: { label: "Researching", cls: "bg-sky-500/15 text-sky-300 border-sky-500/30" },
  writing: { label: "Writing", cls: "bg-violet-500/15 text-violet-300 border-violet-500/30" },
  received: { label: "Received", cls: "bg-zinc-500/15 text-zinc-300 border-zinc-500/30" },
  evidence_review: { label: "Evidence Review", cls: "bg-amber-500/15 text-amber-300 border-amber-500/30" },
  drafting: { label: "Drafting", cls: "bg-zinc-500/15 text-zinc-300 border-zinc-500/30" },
  unable_to_verify: { label: "Unable to Verify", cls: "bg-red-500/15 text-red-300 border-red-500/30" },
};

export default function StatusBadge({ status }) {
  const s = CONTENT_MAP[status] || { label: status, cls: "bg-zinc-500/15 text-zinc-300 border-zinc-500/30" };
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center rounded-sm border px-2 py-0.5 text-[0.65rem] font-ui font-medium uppercase tracking-wider ${s.cls}`}
    >
      {s.label}
    </span>
  );
}
